import React from 'react';
import { useLanguage } from './LanguageProvider';
const languages = [{
  code: 'en',
  name: 'English',
  flag: '🇺🇸',
  label: 'Switch to English'
}, {
  code: 'pt',
  name: 'Português',
  flag: '🇧🇷',
  label: 'Mudar para Português'
}];
export function LanguageSwitcher() {
  const {
    currentLanguage,
    setLanguage
  } = useLanguage();
  return <div className="flex items-center space-x-2" data-id="element-776">
      {languages.map(lang => <button key={lang.code} onClick={() => setLanguage(lang.code)} className={`flex items-center justify-center w-8 h-8 rounded-full border overflow-hidden bg-gray-50 dark:bg-gray-900 transition-all duration-200 hover:scale-110 ${currentLanguage === lang.code ? 'border-blue-500 dark:border-brand-green' : 'border-gray-200 dark:border-gray-800'}`} aria-label={lang.label} title={lang.name} data-id="element-777">
          <span role="img" aria-label={lang.name} className="text-base" data-id="element-778">
            {lang.flag}
          </span>
        </button>)}
    </div>;
}